/** @format */

import React from 'react'

import moment from 'moment'

import { Form, Row, Col, Input, InputNumber, DatePicker } from 'antd'

export default function AproveForm(props) {
	if (props.quotationType === 'magistral') {
		return (
			<Form form={props.form} onFinish={props.handleSendData}>
				<Row>
					<Col span={12}>
						<Form.Item
							name='product'
							rules={[{ required: true, message: 'Producto es requerido' }]}>
							<Input style={{ width: 180 }} placeholder='Nombre del Producto' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name='price'
							rules={[
								{ required: true, message: 'Precio es requerido' },
								() => ({
									validator(_, value) {
										if (/[.]/.test(value))
											return Promise.reject(new Error('El precio no debe contener puntos'))
										return Promise.resolve()
									},
								}),
							]}>
							<InputNumber style={{ width: 180 }} placeholder='Precio' min={1} />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form.Item
							name='schedule'
							rules={[
								{
									required: true,
									message: 'Día de Entrega es requerido',
								},
							]}>
							<DatePicker
								style={{ width: 180 }}
								disabledDate={(item) => item && item < moment().subtract(1, 'day')}
								showTime
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form.Item name='observation'>
							<Input placeholder='Comentarios' style={{ width: 465 }} />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		)
	} else {
		return (
			<Form form={props.form} onFinish={props.handleSendData}>
				<Row>
					<Col span={12}>
						<Form.Item
							name='price'
							rules={[
								{ required: true, message: 'Precio es requerido' },
								() => ({
									validator(_, value) {
										if (/[.]/.test(value))
											return Promise.reject(new Error('El precio no debe contener puntos'))
										return Promise.resolve()
									},
								}),
							]}>
							<InputNumber style={{ width: 180 }} placeholder='Precio' min={1} />
						</Form.Item>
					</Col>
					<Col>
						<Form.Item
							name='schedule'
							rules={[
								{
									required: true,
									message: 'Día de Entrega es requerido',
								},
							]}>
							<DatePicker
								style={{ width: 180 }}
								disabledDate={(item) => item && item < moment().subtract(1, 'day')}
								showTime
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Form.Item name='quantity' rules={[{ required: true, message: 'Cantidad es requerida' }]}>
						<InputNumber style={{ width: 180 }} placeholder='Cantidad' min={1} />
					</Form.Item>
				</Row>
			</Form>
		)
	}
}
